import { Injectable, Inject } from '@angular/core';
import { EndUserModel } from './models/end-user.model';
import {
  RestService,
  RestYiiFilterService,
  RestYiiSort,
  RestYiiPagination,
  RestSimpleResponseParser
} from 'gelios-ng-admin-components';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class EndUserService extends RestService <EndUserModel> {

  public get url(): string {
    return this.environmentApiBasepoint + 'end-user';
  }

  constructor(
    protected http: HttpClient,
    protected _filter: RestYiiFilterService,
    protected _sort: RestYiiSort,
    protected _pagination: RestYiiPagination,
    protected _parser: RestSimpleResponseParser,
    @Inject('ENVIRONMENT_VERSION') protected environmentVersion: string,
    @Inject('ENVIRONMENT_API_BASEPOINT') protected environmentApiBasepoint: string
  ) {
    super(http, _filter, _sort, _pagination, _parser, environmentVersion, environmentApiBasepoint);
    this._filter.searchModelName = 'EndUserSearch';
  }

}
